import type {
  BlendCalculationOutcome,
  BlendCalculationRequest,
  BlendHistoryEntry,
} from '@shared';
import { createLocalBlendsApi } from './localBlendRepository';

/** Device-local calculation/history boundary used by normal application UI. */
export const blendsApi: {
  calculate(req: BlendCalculationRequest): Promise<BlendCalculationOutcome>;
  history(): Promise<BlendHistoryEntry[]>;
  save(request: BlendCalculationRequest, note?: string): Promise<BlendHistoryEntry>;
  deleteHistory(id: string): Promise<{ deleted: boolean }>;
} = createLocalBlendsApi();
